import config from '../config';
import { push } from '/src/utils/navigation';
import CustomNotify from '../components/Notify';

const handleError = (err, callback) => {
    if (callback && err && err.error) {
        callback();
    }

    if (err && err.error) {
        if (err.error.code === 401 || err.error.code === 403) {
            let message = 'Access Denied';
            if (err.error.payload) {
                if (typeof err.error.payload === 'string' && err.error.payload.includes('Access Denied')) {
                    message = err.error.payload;
                } else if (err.error.payload.message) {
                    message = err.error.payload.message;
                }
            }
            CustomNotify(message, 'error', { autoClose: 5000 });
            return;
        }
        
        if (err.error.code === 500 || err.error.code === 0) {
            let message = 'Server error occurred. Please try again later.';
            if (err.error.payload) {
                if (typeof err.error.payload === 'string' && err.error.payload.includes('Access Denied')) {
                    message = 'You don\'t have sufficient permissions for this action';
                }
            }
            
            if (err.error.message) {
                message = err.error.message;
            } else if (err.error.details) {
                message = err.error.details;
            }
            
            CustomNotify(message, 'error', { autoClose: 5000 });
            return;
        }
        
        push(`${config.defaultRoute}500`);
    } else if (err && err.message) {
        let errorMessage = err.message;
        
        if (err.message.includes('JSON')) {
            errorMessage = 'Data format error. Please refresh the page.';
        } else if (err.message.includes('Network')) {
            errorMessage = 'Network error. Please check your connection.';
        } else if (err.message.includes('timeout')) {
            errorMessage = 'Request timeout. Please try again.';
        }
        
        CustomNotify(errorMessage, 'error', { autoClose: 5000 });
    } else {
        CustomNotify('An unexpected error occurred. Please try again later.', 'error', { autoClose: 5000 });
    }
};

export default handleError;